module.exports = __webpack_public_path__ + "img/people_video_bg.42c4469e.jpg";